<template>
  <div>
    <lk-card title="折扣信息">
      <div class="discountCon">
        <lk-form :label-width='120' label-position='right'>
          <lk-row :gutter='16'>
            <lk-col span='10' v-for="(item,index) in promoteDiscountVOList" :key="index"
              :offset='index%2===1?1:0'>
              <lk-form-item :label='`${item.name}:`'>
                <span>{{`${item.cutPrice}元`}}</span>
                <div v-show="item.remark" class="promotionReason">
                  <span>折扣原因：</span>
                  <lk-tooltip :content="item.remark" placement="top-start" class="tip">
                    <div class="reasonTxt">{{item.remark}}</div>
                  </lk-tooltip>
                </div>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </lk-form>
      </div>
    </lk-card>
  </div>
</template>
<script>

export default {
  name: 'DiscountInformation',
  props: {
    promoteDiscountVOList:  {
      type: Array,
    }
  },
  computed: {
  },
  model: {},
  data() {
    return {
    }
  },
  methods: {
  },
};
</script>
<style lang="less" scoped>
.discountCon {
  /deep/ .ivu-form-item-content {
    display: flex;
  }
  /deep/ .ivu-tooltip-inner {
    max-width: none;
  }
}
.promotionReason {
  display: flex;
  margin-left: 8px;
  .reasonTxt {
    width: 150px;
    cursor: pointer;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>
